import { useRef, useState } from 'react';
import { Message } from '../types';

// editingMessageId: which message bubble is currently in edit mode
// editDraft: the live text inside that edit input
// Deliberately owns only this UI state — saving/resending an edit is send
// logic that happens to also clear this state, not edit state that happens
// to send, so it stays in Chat.tsx and calls cancelEdit() when it's done.
export const useMessageEditing = () => {
  const [editingMessageId, setEditingMessageId] = useState<string | null>(null);
  const [editDraft, setEditDraft] = useState<string>('');
  const editRef = useRef<HTMLTextAreaElement | null>(null); // edit textarea focus

  // Enter edit mode for a message bubble — focuses the textarea at end of text
  const startEdit = (msg: Message) => {
    setEditingMessageId(msg.id);
    setEditDraft(msg.content);

    setTimeout(() => {
      const el = editRef.current;
      if (!el) return;
      el.focus();
      const len = el.value.length;
      el.setSelectionRange(len, len);
    }, 0);
  };

  // Discard edits without sending anything (also used after a successful
  // save-and-resend, to clear back out of edit mode).
  const cancelEdit = () => {
    setEditingMessageId(null);
    setEditDraft('');
  };

  return { editingMessageId, editDraft, setEditDraft, editRef, startEdit, cancelEdit };
};
